"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessAgreement = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
class BusinessAgreement extends base_models_1.Serializable {
}
exports.BusinessAgreement = BusinessAgreement;
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '123', description: 'business agreement ID' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "BusinessAgreementID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '0123456789', description: "customer's account ID" }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "AccountID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '', description: 'description of the business agreement' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "Description", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '', description: 'bill belongs to which account ID' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "BillToAccountID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '', description: 'incoming payment method ID' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "IncomingPaymentMethodID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '', description: 'outgoing payment method ID 1' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "OutgoingPaymentMethodID1", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '', description: 'outgoing payment method ID 2' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "OutgoingPaymentMethodID2", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '', description: 'outgoing payment method ID 3' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "OutgoingPaymentMethodID3", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '', description: 'outgoing payment method ID 4' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "OutgoingPaymentMethodID4", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '', description: 'outgoing payment method ID 5' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "OutgoingPaymentMethodID5", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '', description: 'incoming payment bank account ID' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "IncomingPaymentBankAccountID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '', description: 'outgoing payment bank account id' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "OutgoingPaymentBankAccountID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '', description: 'incoming payment card id' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "IncomingPaymentPaymentCardID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '', description: 'outgoing payment card id' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "OutgoingPaymentPaymentCardID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '', description: 'account address id' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "AccountAddressID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '', description: 'bill to account address id' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "BillToAccountAddressID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'NL', description: 'country ID' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "CountryID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '', description: 'alternative payer ID' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "AlternativePayerID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '', description: 'alternative payee ID' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "AlternativePayeeID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'EMOB', description: 'business agreement class' }),
    tslib_1.__metadata("design:type", String)
], BusinessAgreement.prototype, "BusinessAgreementClass", void 0);
